import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import TransactionDetailsTable from './TransactionDetailsTable';
const TransactionDetails = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Transaction Details' parent='Transaction Details'  />
      <Container fluid={true}>
        <Row>
          <TransactionDetailsTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default TransactionDetails;
